export const LogoWordmark = ({ light = false, compact = false }) => (
  <img
    src={light ? "/assets/project-works-logo-dark.svg" : "/assets/logo.png"}
    alt="PROJECT WORKS — Studio Tecnico Associato"
    className={compact ? "w-[220px] md:w-[290px]" : "w-[220px]"}
    data-testid="logo-wordmark"
  />
);
